import styled from "styled-components";
import { Dark, Shadow, White, CoolGray, WerfenColor } from "../../../Constants/ColorChart";
import { Form } from "react-bootstrap";

export const TableWrapper = styled.div`
  margin-top: 3%;
`;

export const RelativeDiv = styled.div`
    position: relative
`;

export const SearchInput = styled.input`
  width: 90%;
  margin: 40px auto 20px auto;
  display: block;
  padding: 8px 12px;
  border: 1px solid ${Shadow};
  color: ${Dark};
  font-size: 16px;
  &::placeholder {
    color: ${Dark};
  }
`;

export const NoResourceMessage = styled.div`
      text-align: center;
    font-size: 20px;
    color: ${Dark};
    display: block;
    margin: 30px auto 30px auto;
`;

export const TabWrapper = styled.div`{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    background-color: ${Dark};
    padding: 0 5%;
}`;
export const ToggleWrapper = styled.div` {
    
    &.toggle-wrapper {
        display: flex;
        align-items: center;
        padding-right: 20px;
        height: 46px;
        .custom-control {
            position: relative;
            display: flex;
            align-items: center;
            line-height: 14px;
        }
        
        .custom-control-label {
            font-size: 20px;
            transition: color 0.3s;
        }
        .inactive {
            color: ${CoolGray};
        }
    }
}`;

export const Label = styled.span`
  margin: 0 10px;
  font-size: 14px;
`;
export const StyledToggle = styled(Form.Check)`{
    
    .custom-control-input {
        width: 50px;
        height: 25px;
        background-color:  ${White};
        border-radius: 15px;
        position: relative;
        transition: background-color 0.3s, box-shadow 0.2s;
        cursor: pointer;
        appearance: none; 
        -webkit-appearance: none;
        display:none;
    }

    label {
        position: relative;
        width: 50px;
        height: 25px;
        background-color:  ${White};
        border-radius: 15px;
        cursor: pointer;
        transition: background-color 0.3s;
        &:before {
            content: "";
            position: absolute;
            top:  3px;
            left: 3px;
            width: 20px;
            height: 20px;
            background-color:  ${WerfenColor};
            border-radius: 50%;
            transition: transform 0.3s;
        }
    }
    .custom-control-input:checked + label {
        background-color: ${White};/* Button background when toggled on */

        &:before {
            transform: translateX(24px); /* Move the circle on toggle */
        }
    }
}`

export const TabSection = styled.div`
  color: ${ White };
  background: ${ Dark };
`;

export const StyledDiv = styled.div`
  color: ${ White };
`;
export const StyledModalBody = styled.div`
    height: 0;
    padding-bottom: 50%;
    iframe {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
`;
